export const EATS_UPLOAD_BUCKET = 'eats';

export const BUSINESS_UPLOAD_FOLDERS = {
  banners: 'banners',
  categoryIcon: 'restaurant',
  product: 'product',
} as const;
export type BusinessUploadFolder =
  (typeof BUSINESS_UPLOAD_FOLDERS)[keyof typeof BUSINESS_UPLOAD_FOLDERS];

export const RESTAURANT_CATEGORY_IMAGE_ENTITY = 'restaurant_category';
export const CATEGORY_ICON_IMAGE_TYPE = 'ICON';
export const CATEGORY_ICON_SELECTOR = 'icon';

export const BUSINESS_LOOKUP_LIMIT = 20;

/** Page size / page cap used when a filtered list walks every page. */
export const BUSINESS_FETCH_ALL_PAGE_SIZE = 100;
export const BUSINESS_FETCH_ALL_MAX_PAGES = 20;
